(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cozy-ugc-videos"] && !Shopify.designMode) return;
  try {
    (function(){
    if(window.__cmsv2)return window.__cmsv2.scan();
    var ic={x:'<svg viewBox="0 0 24 24"><path d="M12 10.6 4.7 3.3 3.3 4.7l7.3 7.3-7.3 7.3 1.4 1.4 7.3-7.3 7.3 7.3 1.4-1.4-7.3-7.3 7.3-7.3-1.4-1.4z"/></svg>',
      l:'<svg viewBox="0 0 24 24"><path d="M15.4 5.4 14 4l-8 8 8 8 1.4-1.4L8.8 12z"/></svg>',
      r:'<svg viewBox="0 0 24 24"><path d="M8.6 5.4 10 4l8 8-8 8-1.4-1.4 6.6-6.6z"/></svg>',
      off:'<svg class="off" viewBox="0 0 24 24"><path d="M5.9 16H2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.9l5.3-4.3a.5.5 0 0 1 .8.4v15.8a.5.5 0 0 1-.8.4zm14.5-4 3.5 3.5-1.4 1.4-3.5-3.5-3.5 3.5-1.4-1.4 3.5-3.5-3.5-3.5 1.4-1.4 3.5 3.5 3.5-3.5 1.4 1.4z"/></svg>',
      on:'<svg class="on" viewBox="0 0 24 24"><path d="M5.9 16H2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.9l5.3-4.3a.5.5 0 0 1 .8.4v15.8a.5.5 0 0 1-.8.4zm13.5 4.1-1.4-1.4A9 9 0 0 0 21 12a9 9 0 0 0-3.3-7l1.4-1.4A11 11 0 0 1 23 12c0 3.2-1.4 6.1-3.6 8.1zm-3.5-3.5-1.4-1.4A4 4 0 0 0 16 12c0-1.4-.8-2.7-1.9-3.4l1.4-1.4A6 6 0 0 1 18 12c0 1.8-.8 3.5-2.1 4.6z"/></svg>'};
    var m=document.createElement('div');m.className='cmsv-modal';m.setAttribute('role','dialog');m.setAttribute('aria-modal','true');
    m.innerHTML='<div class="cmsv-modal__box"><div class="cmsv-modal__media"><video playsinline loop></video>'+
      '<button type="button" class="cmsv-btn cmsv-mute" aria-label="Toggle sound">'+ic.off+ic.on+'</button>'+
      '<button type="button" class="cmsv-btn cmsv-close" aria-label="Close">'+ic.x+'</button>'+
      '<button type="button" class="cmsv-btn cmsv-prev" aria-label="Previous">'+ic.l+'</button>'+
      '<button type="button" class="cmsv-btn cmsv-next" aria-label="Next">'+ic.r+'</button>'+
      '</div></div>';
    document.body.appendChild(m);
    var mv=m.querySelector('video'),mute=m.querySelector('.cmsv-mute'),cards=[],cur=0,sound=true;
    function show(i){
      cur=(i+cards.length)%cards.length;var c=cards[cur];
      if(c.dataset.poster)mv.poster=c.dataset.poster;else mv.removeAttribute('poster');
      mv.src=c.dataset.src;mv.muted=!sound;mute.classList.toggle('is-unmuted',sound);
      var p=mv.play();p&&p.catch(function(){sound=false;mv.muted=true;mute.classList.remove('is-unmuted');mv.play();});
    }
    function close(){m.classList.remove('is-open');mv.pause();mv.removeAttribute('src');mv.load();document.documentElement.style.overflow='';}
    m.querySelector('.cmsv-close').onclick=close;
    m.querySelector('.cmsv-prev').onclick=function(){show(cur-1);};
    m.querySelector('.cmsv-next').onclick=function(){show(cur+1);};
    mute.onclick=function(){sound=!sound;mv.muted=!sound;mute.classList.toggle('is-unmuted',sound);};
    m.addEventListener('click',function(e){if(e.target===m)close();});
    document.addEventListener('keydown',function(e){if(!m.classList.contains('is-open'))return;
      if(e.key==='Escape')close();if(e.key==='ArrowLeft')show(cur-1);if(e.key==='ArrowRight')show(cur+1);});
    var sx=0,box=mv.parentNode;
    box.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
    box.addEventListener('touchend',function(e){var d=e.changedTouches[0].clientX-sx;if(Math.abs(d)>50)show(cur+(d<0?1:-1));});
    document.addEventListener('click',function(e){
      var c=e.target.closest&&e.target.closest('[data-cmsv] .cmsv__card');if(!c)return;
      cards=[].slice.call(c.closest('[data-cmsv]').querySelectorAll('.cmsv__card'));
      m.classList.add('is-open');document.documentElement.style.overflow='hidden';show(cards.indexOf(c));
    });
    var io='IntersectionObserver' in window?new IntersectionObserver(function(es){es.forEach(function(e){
      var v=e.target.querySelector('video');if(!v)return;
      if(e.isIntersecting){var p=v.play();p&&p.catch(function(){});}else v.pause();
    });},{threshold:.4}):null;
    function scan(){
      [].forEach.call(document.querySelectorAll('[data-cmsv] .cmsv__card:not([data-ready])'),function(c){
        c.setAttribute('data-ready','');
        var v=document.createElement('video');
        v.muted=true;v.loop=true;v.playsInline=true;v.setAttribute('playsinline','');v.setAttribute('muted','');v.preload='none';
        if(c.dataset.poster){v.poster=c.dataset.poster;v.src=c.dataset.src;}else{v.preload='metadata';v.src=c.dataset.src+'#t=0.1';}
        c.insertBefore(v,c.firstChild);
        io?io.observe(c):v.play();
      });
    }
    scan();
    new MutationObserver(function(){if(document.querySelector('[data-cmsv] .cmsv__card:not([data-ready])'))scan();})
      .observe(document.body,{childList:true,subtree:true});
    window.__cmsv2={scan:scan};
  })();
  } catch(e) { console.error(e); }
})();

})();
